import { useMemo } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookRunStatus } from "../../../../../api/types/workbookRuns.types";

interface Props {
  reportName: string;
  reportStatus: WorkbookRunStatus | undefined;
  textColorForUpdating?: string;
}

const WorkbookReportItemName = ({ reportName, reportStatus, textColorForUpdating }: Props) => {
  const textColor = useMemo(() => {
    if (!reportStatus && textColorForUpdating) {
      return textColorForUpdating;
    }
    return "text.primary";
  }, [reportStatus, textColorForUpdating]);

  return <TypographyTooltipEllipsis typographyProps={{ variant: "caption", color: textColor }} text={reportName} />;
};

export default WorkbookReportItemName;
